<script setup lang="ts">
import Dialog from "primevue/dialog";
import TrashOutlineIcon from "@/components/shared/icons/TrashOutlineIcon.vue";
import CloseIcon from "@/components/svg-icons/CloseIcon.vue";
import { deleteCommentDialogPt } from "../styles";
import type { DeleteCommentModalProps } from "../types";

withDefaults(defineProps<DeleteCommentModalProps>(), {
  isDeleting: false,
});

const emit = defineEmits<{
  (e: "cancel"): void;
  (e: "confirm"): void;
}>();

const onVisibleChange = (visible: boolean): void => {
  if (!visible) {
    emit("cancel");
  }
};
</script>

<template>
  <Dialog
    :visible="visible"
    modal
    closable
    close-on-escape
    dismissable-mask
    :draggable="false"
    :pt="deleteCommentDialogPt"
    :style="{ width: '460px', maxWidth: '90vw' }"
    @update:visible="onVisibleChange"
  >
    <template #header>
      <TrashOutlineIcon class="w-5 h-5 shrink-0 text-indigo-base" />
      <span class="text-17p font-bold text-indigo-base" data-testid="delete-comment-title">Delete comment</span>
    </template>
    <template #closeicon>
      <CloseIcon size="16" stroke-width="2.4" />
    </template>
    <p class="m-0 text-sm leading-relaxed text-indigo-base" data-testid="delete-comment-body">
      This internal comment and any attached files will be permanently removed. This can't be undone.
    </p>
    <template #footer>
      <button
        type="button"
        class="h-10 px-5 rounded border border-gray-475 bg-transparent text-13p font-bold tracking-[0.4px] text-indigo-base hover:bg-gray-125"
        data-testid="delete-comment-cancel"
        @click="emit('cancel')"
      >
        Cancel
      </button>
      <button
        type="button"
        class="h-10 px-5 rounded border border-teal-900 bg-teal-900 text-13p font-bold tracking-[0.4px] text-white hover:bg-[#006667] disabled:cursor-not-allowed disabled:opacity-70"
        :disabled="isDeleting"
        data-testid="delete-comment-confirm"
        @click="emit('confirm')"
      >
        Delete comment
      </button>
    </template>
  </Dialog>
</template>
